import React from "react";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[Klaro] React render error", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <main
        role="alert"
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          padding: "24px",
          background: "#f8fafc",
          color: "#172033",
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        }}
      >
        <section
          style={{
            width: "min(100%, 520px)",
            padding: "28px",
            border: "1px solid #dde4ee",
            borderRadius: "18px",
            background: "#ffffff",
            textAlign: "center",
            boxShadow: "0 8px 28px rgba(15, 23, 42, 0.08)",
          }}
        >
          <h1 style={{ margin: 0, fontSize: "24px", lineHeight: 1.2 }}>
            Si è verificato un errore imprevisto
          </h1>
          <p style={{ margin: "12px 0 20px", color: "#667085", lineHeight: 1.5 }}>
            Ricarica la pagina per ripristinare Klaro. Se il problema si ripete,
            l'errore resta disponibile nella console del browser per la diagnosi.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              minHeight: "44px",
              padding: "0 20px",
              border: 0,
              borderRadius: "12px",
              background: "#07506d",
              color: "#ffffff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Ricarica pagina
          </button>
        </section>
      </main>
    );
  }
}

export default AppErrorBoundary;
